import { useCallback, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { LastActionsSelector } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/components/LastActionsSelector';
import { StoredBorrowerMenuItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/components/StoredBorrowerItem';
import { LAST_ACTIONS_TIME_SELECTORS } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/constants/LastActionsTimeSelectors';
import { StoredBorrowerOnboardingDetails } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/types';
import { useMerchantPosContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/_shared/contexts/MerchantPosContext';
import { BorrowerOnboardingDetailsMap } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/BorrowerOnboardingDetailsForm/maps/borrowerOnboardingDetails.map';
import { OnboardingDetailsRepositoryFactory } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/entities/OnboardingDetailsRepositoryFactory';
import { TimeSelectionHeader } from '@/components/shared/components/LastActionsSelectOptions/components/TimeSelectionHeader';
import { LastActionsSelectOptions } from '@/components/shared/components/LastActionsSelectOptions/LastActionsSelectOptions';

export const LastBorrowersSelector = () => {
  const { agent } = useMerchantPosContext();
  const { reset } = useFormContext();

  const [borrowerOnboardingDetails, setBorrowerOnboardingDetails] = useState<StoredBorrowerOnboardingDetails[]>([]);

  const getBorrowerOnboardingDetails = useCallback(() => {
    const merchantRepository = OnboardingDetailsRepositoryFactory.getRepository();
    setBorrowerOnboardingDetails(merchantRepository.get(agent.id));
  }, [agent.id]);

  useEffect(() => {
    getBorrowerOnboardingDetails();
  }, []);

  const setValueInForm = (selectedOption: StoredBorrowerOnboardingDetails) => {
    reset(BorrowerOnboardingDetailsMap.fromStoredToForm(selectedOption));
  };

  return (
    <LastActionsSelector
      setSelectedValue={(option) => setValueInForm(option)}
      startIcon={'person'}
      noSelectionLabel={'RECENT_BORROWERS'}
      selectOptions={LastActionsSelectOptions({
        repositoryOptions: borrowerOnboardingDetails,
        renderDisplayElement: (option) => (
          <StoredBorrowerMenuItem
            key={option.id}
            borrowerOnboardingDetails={option}
            getBorrowerOnboardingDetails={getBorrowerOnboardingDetails}
          />
        ),
        timeRanges: LAST_ACTIONS_TIME_SELECTORS,
        timeSelectionHeaderElement: (title) => <TimeSelectionHeader key={title} title={title} />,
      })}
    />
  );
};
